import { render, staticRenderFns } from "./FixedCollectionParameter.vue?vue&type=template&id=a4ca3a0a&scoped=true&"
import script from "./FixedCollectionParameter.vue?vue&type=script&lang=ts&"
export * from "./FixedCollectionParameter.vue?vue&type=script&lang=ts&"
import style0 from "./FixedCollectionParameter.vue?vue&type=style&index=0&id=a4ca3a0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ca3a0a",
  null
  
)

export default component.exports